import React, {
  useContext
} from 'react';

import {
  Subtitle, WhiteTile
} from '../../../StyledComponents';

import {
  AddressTitleTuple
} from './';

import {
  SalesContext
} from './../../../Context/SalesContext';

export const DeliveryDetails = () => {

  const context = useContext(SalesContext);

  let deliveryAddress = '';

  try {
    if (context.deliveryAddressType?.toUpperCase() === 'To another address'.toUpperCase()) {
      deliveryAddress = `${ context.deliveryAddress.unitNumber ? context.deliveryAddress.unitNumber + ', ' : '' }${ context.deliveryAddress.buildingName ? context.deliveryAddress.buildingName + ', ' : '' }${ context.deliveryAddress.streetAddress ?  context.deliveryAddress.streetAddress + ', ' : '' }${ context.deliveryAddress.suburb ? context.deliveryAddress.suburb + ', ' : '' }${ context.deliveryAddress.city ? context.deliveryAddress.city + ', ' : '' }${ context.deliveryAddress.province ? context.deliveryAddress.province + ', ' : '' }${ context.deliveryAddress.postalCode ? context.deliveryAddress.postalCode : '' }`;
    } else {
      deliveryAddress = `${ context.installationAddress.unitNumber ? context.installationAddress.unitNumber + ',' : '' } ${ context.installationAddress.buildingName ? context.installationAddress.buildingName + ',' : '' } ${ context.installationAddress.streetNumber ? context.installationAddress.streetNumber + ' ' : '' }${ context.installationAddress.streetName ? context.installationAddress.streetName + ', ' : '' }${ context.installationAddress.suburb ? context.installationAddress.suburb + ', ' : '' }${ context.installationAddress.city ? context.installationAddress.city + ', ' : '' }${ context.installationAddress.province ? context.installationAddress.province + ', ' : '' }${ context.installationAddress.postalCode ? context.installationAddress.postalCode : '' }`;
    }
  } catch (error) {
    console.log(error);
  }

  const installationAddress = `${ context.installationAddress.unitNumber ? context.installationAddress.unitNumber + ',' : '' } ${ context.installationAddress.buildingName ? context.installationAddress.buildingName + ',' : '' } ${ context.installationAddress.streetNumber ? context.installationAddress.streetNumber + ' ' : '' }${ context.installationAddress.streetName ? context.installationAddress.streetName + ', ' : '' }${ context.installationAddress.suburb ? context.installationAddress.suburb + ', ' : '' }${ context.installationAddress.city ? context.installationAddress.city + ', ' : '' }${ context.installationAddress.province ? context.installationAddress.province + ', ' : '' }${ context.installationAddress.postalCode ? context.installationAddress.postalCode : '' }`;

  return (

    <>

      <Subtitle >
        Address details:
      </Subtitle>

      <WhiteTile>

        <AddressTitleTuple
          title="Installation address:"
          subtitle={installationAddress}
        />

        <br />

        <AddressTitleTuple
          title="Delivery address:"
          subtitle={deliveryAddress}
        />

        <br />

        <AddressTitleTuple
          title="Contact person for delivery:"
          subtitle={`${ context.userDetails?.firstName } ${ context.userDetails?.lastName }  |  ${ context.userDetails?.contactNumber }`}
        />
      </WhiteTile>
    </>
  );
};
